import { useState } from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "./ui/tabs";
import PlanCard from "./PlanCard";
import { weeklyPlans, monthlyPlans } from "../mock";

export default function PlanTabs() {
  const [tab, setTab] = useState("weekly");
  return (
    <Tabs value={tab} onValueChange={setTab} className="w-full">
      <div className="flex justify-center">
        <TabsList className="bg-neutral-100 p-1 rounded-full">
          <TabsTrigger
            value="weekly"
            className="rounded-full px-6 data-[state=active]:bg-green-600 data-[state=active]:text-white"
          >
            Weekly
          </TabsTrigger>
          <TabsTrigger
            value="monthly"
            className="rounded-full px-6 data-[state=active]:bg-green-600 data-[state=active]:text-white"
          >
            Monthly
          </TabsTrigger>
        </TabsList>
      </div>

      <TabsContent value="weekly" className="mt-10">
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4">
          {weeklyPlans.map((p) => (
            <PlanCard key={p.id} plan={p} />
          ))}
        </div>
      </TabsContent>
      <TabsContent value="monthly" className="mt-10">
        <div className="grid gap-6 md:grid-cols-3">
          {monthlyPlans.map((p) => (
            <PlanCard key={p.id} plan={p} />
          ))}
        </div>
      </TabsContent>
    </Tabs>
  );
}
